import { render, staticRenderFns } from "./CreatePrepayment.vue?vue&type=template&id=28427150&scoped=true&"
import script from "./CreatePrepayment.vue?vue&type=script&lang=js&"
export * from "./CreatePrepayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28427150",
  null
  
)

export default component.exports